




import { observable, action, computed } from 'mobx';
import { getIDs } from '../components/Matrix/functions/getID';
import { IOrgStageCoordsGetterOutput } from '../components/Matrix/functions/getOrgStages-1';
import { RootStore } from './RootStore';


export const AlignmentsList: Alignment[] = ['left','right','center', 'end' , 'start',]

export type Alignment = 'left'|'right'|'center' | 'end' | 'start' | 'justify' | 'revert'

export class DebuggingStore {

    rootStore = RootStore;
    constructor(rootStore: any) {
        this.rootStore = rootStore
    }

    @observable alignment: Alignment = 'right'

    @action setAlignment = (a: Alignment) => this.alignment = a

}